import axios from "axios";
const axiosMain = axios.create({
  baseURL: process.env.VUE_APP_MAIN_API_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" }
});

axiosMain.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem("authToken")}`;
  return config;
});

export default axiosMain;